export const PAGE_LANDING = 'landing';
export const PAGE_FILES = 'files';
export const PAGE_AUTH = 'auth';